import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { EditGroupForm } from '../EditGroupForm'
import { useIsCurrentUserGroup } from '@/modules/manage-member/hooks/useIsCurrentUserGroup'
import showErrorToast from '@/common/utils/showErrorToast'
import { Navigate, useParams } from 'react-router-dom'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function EditGroupListing() {
	const { id } = useParams()
	const isCurrentUserGroup = useIsCurrentUserGroup(id!)

	if (isCurrentUserGroup) {
		showErrorToast('ไม่สามารถแก้ไขกลุ่มผู้ใช้งานของตัวเองได้')
		return <Navigate to="/operator/member-group-list" replace />
	}
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขกลุ่มผู้ใช้งาน`}
					description="แก้ไขกลุ่มผู้ใช้งาน"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<EditGroupForm />
		</div>
	)
}
